// eslint-disable-next-line no-undef
const nav = document.querySelector('.dropdown-menu-nav');
// eslint-disable-next-line no-undef
const dropdown = document.querySelector('.navigation--dropdown-menu');
// eslint-disable-next-line no-use-before-define
dropdown.addEventListener('click', toggle_dropdown_menu);
// eslint-disable-next-line camelcase,no-undef
const menu_icon_default = document.querySelector('.dropdown-inactive-svg');
// eslint-disable-next-line camelcase,no-undef
const menu_icon_active = document.querySelector('.dropdown-active-svg');

// eslint-disable-next-line camelcase
function toggle_dropdown_menu() {
  if (nav.style.display === 'flex') {
    nav.style.display = 'none';
    menu_icon_default.style.display = 'flex';
    menu_icon_active.style.display = 'none';
  } else {
    nav.style.display = 'flex';
    menu_icon_default.style.display = 'none';
    menu_icon_active.style.display = 'flex';
  }
}
